import { RESET_FORM } from '../actionTypes';
import { companyUsersActions } from '../reducer';

export default () => companyUsersActions[RESET_FORM]();
